import React, { useState, useEffect, useRef } from "react";
import SuperAdminSidebar from "../SuperAdminSidebar";
import ManagerSidebar from "../ManagerSidebar";
import LeaderSidebar from "../LeaderSidebar";
import MemberSidebar from "../MemberSidebar";
import AdminNavbar from './AdminNavbar';
import './BalanceSheet.css';

const BalanceSheet = () => {

    const userType = localStorage.getItem("usertype");

return (
        <div className="admin-container">
            <div className="sidebar-container">
                {userType === "administrator" && <SuperAdminSidebar />}
                {userType === "leader" && <LeaderSidebar />}
                {userType === "manager" && <ManagerSidebar />}
                {userType === "member" && <MemberSidebar />}
            </div>

            <div className="admin-content">
                <AdminNavbar />

                <div className="main-content">

                    <div className="main-section">
                        <h3 className="section-title">Balance Sheet</h3>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default BalanceSheet;